import React from "react";

export const Subscribe = ({ btn, input }) => {
  return (
    <div
      className="newsletter"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "64px",
      }}
    >
      {/* Begin Mailchimp Signup Form */}
      <div id="mc_embed_signup">
        <form
          action="https://nisamerica.us11.list-manage.com/subscribe/post?u=e8fc423eff95099d1ffcc6009&id=349f7d20f9"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          target="_blank"
          noValidate
        >
          <div className="flex">
            <input
              type="email"
              defaultValue=""
              name="EMAIL"
              className={input}
              id="mce-EMAIL"
              placeholder="email address"
              required
            />
            {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups*/}
            <div
              style={{ position: "absolute", left: "-5000px" }}
              aria-hidden="true"
            >
              <input
                type="text"
                name="b_e8fc423eff95099d1ffcc6009_349f7d20f9"
                tabIndex={-1}
                defaultValue
              />
            </div>

            <input
              type="submit"
              value="Subscribe"
              name="subscribe"
              id="mc-embedded-subscribe"
              className={btn}
              data-label="Subscribe"
            />
          </div>
        </form>
      </div>
      {/*End mc_embed_signup*/}
    </div>
  );
};
